import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Avatar,
  LinearProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Skeleton,
} from "@mui/material";
import Tooltip from '@mui/material/Tooltip';
import { Link } from "react-router-dom";
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';

const membersData = [
  {
    name: "Salona Mishra",
    role: "Project Manager",
    today: 70,
    thisWeek: 85,
  },
  {
    name: "Ilqa Rasul",
    role: "Project Manager",
    today: 50,
    thisWeek: 60,
  },
  {
    name: "Divya Goel",
    role: "Project Manager",
    today: 90,
    thisWeek: 95,
  },
  {
    name: "Ravi Kumar",
    role: "Product Designer",
    today: 75,
    thisWeek: 80,
  },
];

// Skeleton loader component for this table
const MembersProgressLoader = ({ rowsNum }) => {
  return [...Array(rowsNum)].map((_, index) => (
    <TableRow key={index}>
      <TableCell>
        <Skeleton variant="text" width={20} height={30} />
      </TableCell>
      <TableCell>
        <Box display="flex" alignItems="center" gap={2}>
          <Skeleton variant="circular" width={40} height={40} />
          <Box sx={{ flex: 1 }}>
            <Skeleton variant="text" width={120} height={20} />
            <Skeleton variant="text" width={80} height={15} />
          </Box>
        </Box>
      </TableCell>
      <TableCell>
        <Skeleton variant="text" width="100%" height={40} />
      </TableCell>
      <TableCell>
        <Skeleton variant="text" width="100%" height={40} />
      </TableCell>
    </TableRow>
  ));
};

const MembersProgress = () => {
  const [members, setMembers] = useState(null);

  useEffect(() => {
    // Simulate async data loading
    setTimeout(() => {
      setMembers(membersData);
    }, 2000);
  }, []);

  return (
    <Paper className="card-body p-20 bg-base border rounded-3 h-100" sx={{ boxShadow: 'none' }}>
      <Box display="flex" justifyContent="space-between" sx={{ flexWrap: { sm: 'wrap' } }} className="pb-16 mb-0 border-bottom" mb={2}>
        <h6 className=" fw-semibold mb-0" style={{ fontSize: '17px' }}>Members  <Tooltip title="Members" arrow placement="top">
          <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
            <InfoOutlineIcon fontSize="small" />
          </button>
        </Tooltip></h6>
        <Link to="/time-and-activity"
          style={{ cursor: "pointer", fontSize: '14px', color: '#004DFF', }}
        >
          View report
        </Link>

      </Box>

      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>#</TableCell> {/* Counter header */}
              <TableCell>Member info</TableCell>
              <TableCell align="center">Today</TableCell>
              <TableCell align="center">This week</TableCell>
            </TableRow>
          </TableHead>
          <TableBody
            sx={{
              "& .MuiTableCell-root": {
                borderBottom: "none", // 🔥 remove table body cell borders
              },
            }}
          >
            {!members ? (
              <MembersProgressLoader rowsNum={4} />
            ) : (
              members.map((member, index) => (
                <TableRow key={index}>
                  <TableCell>{index + 1}</TableCell> {/* Counter number */}

                  <TableCell>
                    <Box display="flex" alignItems="center" gap={1}>
                      <Avatar sx={{ bgcolor: "#1976d2", fontSize: '14px', }}>
                        {member.name
                          .split(" ")
                          .map((word) => word[0])
                          .join("")
                          .toUpperCase()}
                      </Avatar>
                      <Box>
                        <Typography variant="body1" sx={{ fontSize: '14px', fontWeight: 600, color: '#1A1F36', }}>{member.name}</Typography>
                        <Typography variant="caption" color="text.secondary">
                          {member.role}
                        </Typography>
                      </Box>
                    </Box>
                  </TableCell>

                  <TableCell align="center">
                    <Typography variant="body2" sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 1, }} mb={0.5}>
                      <LinearProgress
                        variant="determinate"
                        value={member.today}
                        sx={{
                          height: 10,
                          borderRadius: 10,
                          width: '80px',
                          '& .MuiLinearProgress-bar': {
                            backgroundColor: '#004DFF',  // Your custom color here (green as example)
                          },
                        }}
                      />
                      {member.today}%
                    </Typography>

                  </TableCell>

                  <TableCell align="center">
                    <Typography variant="body2" sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 1, }} mb={0.5}>
                      <LinearProgress
                        variant="determinate"
                        value={member.thisWeek}
                        sx={{
                          height: 10,
                          borderRadius: 10,
                          width: '80px',
                          '& .MuiLinearProgress-bar': {
                            backgroundColor: '#004DFF',  // Your custom color here (green as example)
                          },
                        }}
                      /> {member.thisWeek}%
                    </Typography>

                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default MembersProgress;
